<template>
  <div id="mobileMenuBar">
    <div class="toggle-hamburger clickable" @click="expand" @keypress.enter="expand">
      <div class="hamburger-line" />
      <div class="hamburger-line" />
      <div class="hamburger-line" />
    </div>
  </div>
</template>

<script setup>
const emit = defineEmits(['expand']);

function expand() {
  emit('expand');
}
</script>

<script>
export default {
  name: 'MobileMenuBar',
};
</script>
